import { gsap } from "gsap";
import { SplitText as SplitTextPlugin } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export class TextOverflow {
  constructor() {
    this._elements = document.querySelectorAll("[animation-text-overflow]");
    this.init();
  }

  init() {
    gsap.registerPlugin(SplitTextPlugin);
    gsap.registerPlugin(ScrollTrigger);
    if (!this._elements || window.innerWidth < 768) return;

    this._elements.forEach((el) => {
      const split = SplitTextPlugin.create(el, {
        type: "lines, words",
        mask: "lines",
        autoSplit: true,
      });

      gsap.from(split.words, {
        duration: 1,
        y: 100,
        autoAlpha: 0,
        stagger: 0.2,
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom 50%",
          toggleActions: "play none none reverse",
        },
      });
    });
  }
}
